import { useEffect } from 'react';

function useOutsideClick(ref: HTMLDivElement | null, callback: () => void) {
  const handleClick = (event: unknown) => {
    if (ref && !ref.contains((event as { target: Node | null }).target)) {
      callback();
    }
  };
  useEffect(() => {
    if (!ref) return;
    document.removeEventListener('mousedown', handleClick);
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [ref]);
}

export default useOutsideClick;
